<template>
  <el-dialog :visible.sync="visible" width="700">
    <div slot="title">
      <QS-icon name="QS-icon-multi-info"></QS-icon>
      <span>保存模板</span>
    </div>
    <div class="content">
      <p>保存为租赁方案模板，便于下次直接使用。您可以自定义修改方案名称。</p>
      <el-form>
        <el-form-item label="方案名称">
          <el-input v-model="formData.name" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button @click="cancelDialog">暂时不用</el-button>
      <el-button type="primary" @click="savePlan" :loading="loading">保存</el-button>
    </div>
  </el-dialog>
</template>
<script setup>
import { ref } from 'vue'
import { omit } from 'lodash'
import { createPersonalPlan } from '@/api/domain/purchase'
import { Message } from '@qs/ui'
import { quick } from '@/utils/ba'
import { trackClick } from '@/utils/trackReport'

const loading = ref(false)
const visible = ref(false)
// 租赁方案保存时的参数
const formData = ref({
  name: '',
})

const emit = defineEmits(['saveSuccess'])
const showDialog = (params) => {
  visible.value = true
  formData.value = params
  // 埋点统计曝光次数
  quick('view', 'personal_sign_contract_plan_view')
  trackClick('personal_sign_contract_plan_view')
}

const savePlan = async () => {
  loading.value = true
  try {
    // 埋点统计点击保存按钮次数
    quick('click', 'personal_sign_contract_plan_ok_click')
    trackClick('personal_sign_contract_plan_ok_click')
    const postParams = omit(formData.value, ['id'])
    const { code, data } = await createPersonalPlan(postParams)
    if (code === 1) {
      visible.value = false
      Message.success(`${formData.value.name}已保存成功，下次签约可直接选择使用`)
      emit('saveSuccess', {
        isNew: true,
        id: data,
        name: formData.value.name,
      })
    }
  } finally {
    loading.value = false
  }
}
const cancelDialog = () => {
  quick('click', 'personal_sign_contract_plan_cancel_click')
  trackClick('personal_sign_contract_plan_cancel_click')
  visible.value = false
  emit('saveSuccess', {
    isNew: false,
  })
}
defineExpose({
  showDialog,
})
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #1D2129;
  border-bottom: 0;
}
::v-deep .el-dialog__body {
  padding-top: 0;
  color: #1D2129;
  .el-form-item {
    display: flex;
    margin-top: 8px;
    border: 1px solid #E5E6EB;
    border-radius: 6px;
    .el-form-item__label {
      width: 80px;
      background: #F7F8FA;
      padding-right: 0;
      border-right: 1px solid #E5E6EB;
      color: #4E5969;
      justify-content: center;
    }
    .el-form-item__content {
      width: 100%;
      .el-input__inner {
        border: 0;
      }
    }
  }
}
</style>
